// extracted by mini-css-extract-plugin
export default {"root":"dSp3rIK5rGx2GyoptxOU","placeHolderShimmer":"f_302I28zzOc1xSV4tuA"};